import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const FILES_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"files"> = {};
